export const CARGAR_GASTOSIMPORTACION = 'CARGAR_GASTOSIMPORTACION';
export const CARGAR_IMPORTACION = 'CARGAR_IMPORTACION';
export const CARGAR_AJUSTE_PLAN_PAGO = 'CARGAR_AJUSTE_PLAN_PAGO';
